import { observable } from "mobx";
import { Type } from "class-transformer";
import DateTimeOffsetRangeRequest from "./dateTimeOffsetRangeRequest";
import IntegerRangeRequest from "./integerRangeRequest";
import KafkaDltMessageType from "./kafkaDltMessageType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DeadLetterTopicMessagesSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  @Type(() => DateTimeOffsetRangeRequest)
  originalProducedAtRange?: DateTimeOffsetRangeRequest;

  @observable
  messageType?: KafkaDltMessageType;

  @observable
  @Type(() => IntegerRangeRequest)
  deliveryAttemptsRange?: IntegerRangeRequest;
}
